import axios from 'axios';
import { LoadingStates } from 'shared/constants/loadingStates';
import { clearPlantDesignForm } from 'plantItemNew/redux/slices/formSlice';
import { PLANT_DESIGN_API_BASE_URL } from 'plantDesign/constants/plantDesignConstants';

const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

const initialState = {
  pdfData: null,
  pdfState: '',
};

const plantDesignPdfLinkSlice = createSlice({
  name: 'plantDesignPdfLink',
  initialState,
  reducers: {
    cleanPlantDesignPdf() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(clearPlantDesignForm, () => {
        return initialState;
      })
      .addCase(downloadPlantDesignApplicationPDF.pending, (state) => {
        state.pdfData = null;
        state.pdfState = LoadingStates.Loading;
      })
      .addCase(downloadPlantDesignApplicationPDF.rejected, (state) => {
        state.pdfData = null;
        state.pdfState = LoadingStates.Rejected;
      })
      .addCase(downloadPlantDesignApplicationPDF.fulfilled, (state, action) => {
        state.pdfData = action.payload ?? null;
        state.pdfState = LoadingStates.Succeeded;
      });
  },
});

export const downloadPlantDesignApplicationPDF = createAsyncThunk(
  'plantDesignPdfLink/downloadPdf',
  async (applicationId) => {
    const resp = await axios.post(
      `${PLANT_DESIGN_API_BASE_URL}/generatepdf/${applicationId}`,
      {},
      {
        responseType: 'blob',
      },
    );

    return resp.data;
  },
  {
    condition: (_, { getState, extra }) => {
      const pdfLink = getState().plantDesignPdfLink;
      return pdfLink.pdfState !== LoadingStates.Loading;
    },
  },
);

export const { cleanPlantDesignPdf } = plantDesignPdfLinkSlice.actions;
export const plantDesignPdfLinkReducer = plantDesignPdfLinkSlice.reducer;
